const parseLimitValue = (limit) => (limit === '' ? null : parseInt(limit, 10))

export const prepareValuesForPreview = (eventType, formValues) => {
  if (!formValues.eventLimitsInitialized) {
    return {
      event_limit: eventType.event_limit
    }
  }

  return ({
    event_limit: (
      {
        ...(eventType.event_limit ? eventType.event_limit : {}),
        daily_limit: parseLimitValue(formValues.dailyLimit),
        weekly_limit: parseLimitValue(formValues.weeklyLimit),
        monthly_limit: parseLimitValue(formValues.monthlyLimit)
      }
    )
  })
}
